<template>
  <div class="login">
    <div class="loginbox">
      <ul class="boxhead" v-if="!needBindMobile">
        <li
          :class="glID == item.id ? 'gl' : ''"
          v-for="item in loginMenu"
          :key="item.id"
          @click="ChangeHandle(item.id)"
        >
          <span>{{ item.name }}</span>
        </li>
      </ul>
      <div class="boxcontent">
        <div class="loginForm" v-show="glID === 1">
          <div class="formcontent">
            <el-form
              label-position="center"
              hide-required-asterisk
              :rules="rules"
              label-width="80px"
              :model="LoginForm"
              ref="LoginForm"
            >
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model.trim="LoginForm.mobile"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="password" v-if="isPasswordMode">
                <el-input
                  v-model.trim="LoginForm.password"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item
                label="验证码"
                prop="verificationCode"
                id="spendCode"
                v-else
              >
                <el-input
                  v-model.trim="LoginForm.verificationCode"
                  oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                  >.
                  <el-button
                    slot="append"
                    class="codebutton"
                    v-if="countDownShow"
                    >{{ time }}秒后可重新发送</el-button
                  >
                  <el-button
                    slot="append"
                    class="codebutton"
                    v-else
                    @click="codeHandle()"
                    >发送验证码</el-button
                  >
                </el-input>
              </el-form-item>
              <div class="wechat flex_layout" v-if="!needBindMobile">
                <div class="wechaticon">
                  <div
                    style="cursor: pointer"
                    @click="getwechatoauth"
                    target="_self"
                    class="flex_layout"
                  >
                    <img src="../assets/image/wx.webp" alt="" /><span
                      >微信登录</span
                    >
                  </div>
                </div>
                <div class="forgetpassword" @click="changeCode()">
                  <span>{{ isPasswordMode ? "验证码登录" : "密码登录" }}</span>
                </div>
              </div>
              <el-form-item id="mylogin" v-if="!needBindMobile">
                <el-button
                  id="loginbtn"
                  type="primary"
                  @click="submitForm('LoginForm')"
                  >登录</el-button
                >
              </el-form-item>
            </el-form>
            <div class="goregister" v-if="!needBindMobile">
              没有账号？ <span @click="ChangeHandle(2)">立即注册</span>
            </div>
          </div>
        </div>
        <div class="registerForm" v-show="glID === 2">
          <el-form
            label-position="center"
            hide-required-asterisk
            :rules="rules"
            label-width="80px"
            :model="registerForm"
            ref="registerForm"
          >
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model.trim="registerForm.mobile"></el-input>
            </el-form-item>

            <el-form-item label="密码" prop="password">
              <el-input
                v-model.trim="registerForm.password"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input
                v-model.trim="registerForm.confirmPassword"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="verificationCode" id="spendCode">
              <el-input
                v-model.trim="registerForm.verificationCode"
                oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                >.
                <el-button slot="append" class="codebutton" v-if="countDownShow"
                  >{{ time }}秒后可重新发送</el-button
                >
                <el-button
                  slot="append"
                  class="codebutton"
                  v-else
                  @click="codeHandle2()"
                  >发送验证码</el-button
                >
              </el-input>
            </el-form-item>
            <el-form-item id="mylogin" v-if="!needBindMobile">
              <el-button
                id="loginbtn"
                type="primary"
                @click="submitForm2('registerForm')"
                >注册并登录</el-button
              >
            </el-form-item>
            <el-form-item id="mylogin" v-if="needBindMobile">
              <el-button
                id="loginbtn"
                type="primary"
                @click="submitFormBind('registerForm')"
                >绑定手机号</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  spendCode,
  userLogin,
  registerUserPc,
  bindingMobile,
} from "../views/API/login";
import { setToken } from "../assets/js/storage";
import { WECHATAUTH, WECHATREDITECT } from "../assets/js/config";
export default {
  props: {
    needBindMobile: {
      type: Boolean,
      default: false,
    },
    isWeChat: {
      type: Boolean,
    },
  },
  data() {
    // 自定义确认密码校验函数
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.registerForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      countDownShow: false,
      time: 60, // 倒计时
      isPasswordMode: true,
      // 登录
      LoginForm: {
        mobile: "",
        password: "",
        verificationCode: "",
      },
      // 注册
      registerForm: {
        mobile: "",
        verificationCode: "",
        password: "",
        confirmPassword: "",
      },
      rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "change" },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
            message: "请输入正确的电话号码",
            trigger: "blur",
          },
        ],
        verificationCode: [
          { required: true, message: "请输入验证码", trigger: "change" },
          { min: 6, max: 6, message: "长度应该是6个数字", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 8,
            max: 32,
            message: "密码长度需要包含字母和数字且大于8位数",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
      },
      loginMenu: [
        {
          name: "用户登录",
          id: 1,
          state: true,
        },
        {
          name: "账号注册",
          id: 2,
          state: false,
        },
      ],
      glID: 1,
      formShow: true,
      token: "",
    };
  },
  created() {
    console.log("是否需要绑定手机:", this.needBindMobile);
    if (this.needBindMobile) {
      this.isPasswordMode = false;
      this.glID = 2;
    }
    this.token = localStorage.getItem("Authorization")
      ? localStorage.getItem("Authorization")
      : "";
  },
  methods: {
    getwechatoauth() {
      const params = {
        app_id: "uc59f60a1a2a653b84",
        wx_appid: this.isWeChat ? "wxbe1f54686f3f8cf5" : "wxcad35ef28950af2e",
        redirect: WECHATREDITECT,
      };
      return window.open(
        WECHATAUTH +
          `?app_id=${params.app_id}&wx_appid=${params.wx_appid}&redirect=${params.redirect}`,
        "_self",
      );
    },

    changeCode() {
      this.isPasswordMode = !this.isPasswordMode;
    },
    // 登录发验证码
    async codeHandle() {
      let str = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
      var state = this.LoginForm.mobile.search(str);
      if (this.LoginForm.mobile !== "" && state !== -1) {
        const res = await spendCode({
          mobile: this.LoginForm.mobile,
          type: "login",
        });
        if (res.data.code == 1) {
          this.$message({
            message: "发送成功",
            type: "success",
          });
        } else {
        }
        // 60秒倒计时
        this.countDownShow = true;
        let timer = setInterval(() => {
          this.time--;
          if (this.time <= 0) {
            this.countDownShow = false;
            this.time = 60;
            return clearInterval(timer);
          }
        }, 1000);
      }
      // return this.$refs.LoginForm.validateField("mobile");
    },
    // 注册发验证码
    async codeHandle2() {
      let str = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
      var state = this.registerForm.mobile.search(str);
      if (this.registerForm.mobile !== "" && state !== -1) {
        const res = await spendCode({
          mobile: this.registerForm.mobile,
          type: this.needBindMobile ? "bind_mobile" : "register",
        });
        if (res.data.code == 1) {
          this.$message({
            message: "发送成功",
            type: "success",
          });
        } else {
        }
        // 60秒倒计时
        this.countDownShow = true;
        let timer = setInterval(() => {
          this.time--;
          if (this.time <= 0) {
            this.countDownShow = false;
            this.time = 60;
            return clearInterval(timer);
          }
        }, 1000);
      }
      // return this.$refs.LoginForm.validateField("mobile");
    },
    ChangeHandle(id) {
      this.glID = id;
    },
    // PC登录
    async pcloginHandle(data) {
      const filterData = this.filteredObj(data);
      const res = await userLogin(filterData);
      if (res.data.code == 1) {
        // 登录成功
        this.$message({
          message: "登录成功",
          type: "success",
        });
        setToken(res.data.data.accessToken);
        this.$emit("closeDialogHandle"); //关闭弹出窗
        localStorage.setItem("ActiveMenuName", "User");
        localStorage.setItem(
          "UserInfo",
          JSON.stringify(res.data.data.userInfo),
        );
        return this.$router.push({ name: "User" });
      } else {
        // return this.$message(res.data.msg);
      }
    },
    // 绑定手机号
    submitFormBind(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await bindingMobile(this.registerForm);
          if (res.data.code == 1) {
            // 登录成功
            this.$message({
              message: "登录成功",
              type: "success",
            });
            setToken(res.data.data.accessToken);
            this.$emit("closeDialogHandle"); //关闭弹出窗
            localStorage.setItem("ActiveMenuName", "User");
            localStorage.setItem(
              "UserInfo",
              JSON.stringify(res.data.data.userInfo),
            );
            return this.$router.push({ name: "User" });
          }
        } else {
          return false;
        }
      });
    },
    // PC登录表单校验
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.pcloginHandle(this.LoginForm);
        } else {
          return false;
        }
      });
    },
    // PC注册
    submitForm2(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await registerUserPc(this.registerForm);
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.pcloginHandle({
              mobile: this.registerForm.mobile,
              password: this.registerForm.password,
            });
          } else {
            return this.$message.error(res.data.msg);
          }
        } else {
          return false;
        }
      });
    },
    filteredObj(obj) {
      const filteredObj = Object.entries(obj).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {});
      return filteredObj;
    },
  },
};
</script>
<style scoped lang="scss">
.login {
  padding: 20px 40px;
  background: #ffffff;
  border-radius: 0 0 10px 10px;
  @media screen and (max-width: 540px) {
    padding: 20px;
  }
  .loginbox {
    width: 100%;
    margin: 0px auto;
    @media screen and (max-width: 540px) {
      width: 100%;
      margin-bottom: 20px;
    }
    .boxhead {
      width: 100%;
      margin: 0px 0px 20px 0;
      border-radius: 10px 10px 0px 0px;
      overflow: hidden;
      li {
        color: #757477;
        font-size: 20px;
        width: 50%;
        height: 100%;
        float: left;
        text-align: center;
        cursor: pointer;
      }
      .gl {
        color: #293f8e;
        position: relative;
        span {
          font-weight: 600;
          font-size: 20px;
        }
      }
    }
    .boxcontent {
      background-color: #ffffff;
      .codebutton {
        @media screen and (max-width: 540px) {
          padding: 0 2px;
          font-size: 12px;
        }
      }
      .title {
        text-align: center;
        color: #666666;
        font-size: 16px;
        padding: 17px 0;
      }
      .loginForm {
        .goregister {
          text-align: center;
          span {
            color: #05258e;
            cursor: pointer;
          }
        }
        .formcontent {
          .el-form-item {
            height: 46px;
          }
          ::v-deep .el-form-item__label {
            line-height: 46px;
            border: 1px solid #dcdfe6;
            border-right: none;
            height: 46px;
          }
          ::v-deep .el-input__inner {
            line-height: 46px;
            height: 46px;
            border-radius: 0;
          }
          #loginbtn {
            padding: 0;
            width: 100%;
            color: #ffffff;
            font-size: 18px;
            height: 46px;
            background: #293f8e;
            border-radius: 2px;
            @media screen and (max-width: 540px) {
              width: 100%;
            }
          }
          #mylogin {
            margin-top: 30px;
            ::v-deep .el-form-item__content {
              margin-left: 0 !important;
            }
          }
          .wechat {
            justify-content: space-between;
            a {
              display: flex;
              align-items: center;
              cursor: pointer;
            }
            img {
              margin-right: 5px;
            }
            .forgetpassword {
              cursor: pointer;
            }
          }
          #spendCode {
            ::v-deep .el-input-group__append {
              color: #293f8e;
              cursor: pointer;
            }
          }
        }
      }

      .registerForm {
        .el-form-item {
          height: 46px;
        }
        ::v-deep .el-form-item__label {
          line-height: 46px;
          border: 1px solid #dcdfe6;
          border-right: none;
          height: 46px;
        }
        ::v-deep .el-input__inner {
          line-height: 46px;
          height: 46px;
          border-radius: 0;
        }
        #loginbtn {
          padding: 0;
          width: 100%;
          color: #ffffff;
          font-size: 18px;
          height: 46px;
          background: #293f8e;
          border-radius: 2px;
          @media screen and (max-width: 540px) {
            width: 100%;
          }
        }
        #mylogin {
          margin-top: 30px;
          ::v-deep .el-form-item__content {
            margin-left: 0 !important;
          }
        }
        .wechat {
          cursor: pointer;
          display: flex;
          align-items: center;
          img {
            margin-right: 5px;
          }
        }
        #spendCode {
          ::v-deep .el-input-group__append {
            color: #293f8e;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
